import React, { ReactNode, useState, useRef } from "react";

interface FlagProps {
  children: ReactNode;
  tooltipContent?: ReactNode;
  className?: string;
  triggerClassName?: string;
}

const Flag = ({ children, tooltipContent, className = "", triggerClassName = "" }: FlagProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 300); // 300ms delay to hide
  };

  return (
    <div 
      className={`relative ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
        <div className={triggerClassName}>
            {children}
        </div>
        {tooltipContent && (
             <div className={`absolute left-1/2 transform -translate-x-1/2 top-full mt-2 transition-opacity duration-300 z-50 ${isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
               {tooltipContent}
                <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white dark:bg-gray-800 border-l border-t border-gray-200 dark:border-gray-600 rotate-45"></div>
             </div>
        )}
    </div>
  );
};

export default Flag;